'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = require('react-redux');

var _reactJplayerUtils = require('react-jplayer-utils');

var _actions = require('../actions/actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Connect = function Connect(jPlayer, options) {
  var ConnectedPlayer = (0, _reactRedux.connect)(function (state) {
    return state;
  }, _extends({}, actions))(jPlayer);

  return (0, _reactJplayerUtils.connect)(jPlayer, { options: options }, ConnectedPlayer);
};

exports.default = Connect;